/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { FormState } from '@gh/common-shared';
import { UploadSlot } from '@gh/core-ui';

export abstract class ComponentOrItemFormState<T> extends FormState<T> {
  pictureSlot: UploadSlot;
}
